import React, { FC, useState } from 'react';
import Button from '../../../../components/button';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { useTranslation } from 'react-i18next';
import { CSSObject } from '@mui/material';
import CSVUsersUploadDialog from '../csv-users-upload-dialog';

interface CSVUsersUploadProps {
    sx?: CSSObject;
    refetchData: () => void;
}

export const STATUS = {
    IDLE: 'IDLE',
    LOADING: 'Loading',
    FINALIZING: 'Finalizing',
    COMPLETED: 'Completed',
} as const;

const CSVUsersUpload: FC<CSVUsersUploadProps> = ({ sx, refetchData }) => {
    const { t } = useTranslation();

    const [isModalShown, showModal] = useState(false);

    const onModalOpen = () => {
        showModal(true);
    };

    const onModalClose = () => {
        showModal(false);
        refetchData();
    };

    return (
        <>
            <Button
                icon={FileUploadOutlinedIcon}
                label={t('csv')}
                size='large'
                onClick={onModalOpen}
                variant='outlined'
                sx={sx}
                testId='upload-csv'
            />
            {isModalShown && <CSVUsersUploadDialog onModalClose={onModalClose} isModalShown={isModalShown} />}
        </>
    );
};

export default CSVUsersUpload;
